package com.schoolconnect.app.datasource.network.request

import kotlinx.serialization.EncodeDefault
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class AcademicYearCreateRequest(
    @SerialName("school_id")
    val schoolId: String,
    @SerialName("label")
    val label: String,
    @SerialName("start_date")
    val startDate: String,
    @SerialName("end_date")
    val endDate: String,
    @SerialName("lifecycle")
    val lifecycle: String,
    @EncodeDefault
    @SerialName("is_active")
    val isActive: Boolean = true
)

@Serializable
data class AcademicYearUpdateRequest(
    @SerialName("label")
    val label: String? = null,
    @SerialName("start_date")
    val startDate: String? = null,
    @SerialName("end_date")
    val endDate: String? = null,
    @SerialName("is_active")
    val isActive: Boolean? = null,
    @SerialName("lifecycle")
    val lifecycle: String? = null
)

@Serializable
data class AcademicYearToggleActiveRequest(
    @SerialName("is_active")
    val isActive: Boolean
)
